import React, { useCallback, useContext, useState } from "react";

import { notImplementedError } from "utils/common";

const DueDiligenceFiltersContext = React.createContext({
  showOnlyAISummaryFiles: false,
  toggleShowOnlyAISummaryFiles: notImplementedError,
  showOnlyUpdatedFields: false,
  toggleShowOnlyUpdatedFields: notImplementedError,
  showOnlyFileFields: false,
  toggleShowOnlyFileFields: notImplementedError,
});

export interface IDueDiligenceFiltersContextProvider {
  children?: React.ReactNode;
}

export const DueDiligenceFiltersContextProvider = ({
  children,
}: IDueDiligenceFiltersContextProvider) => {
  const [showOnlyAISummaryFiles, setShowOnlyAISummaryFiles] = useState(false);
  const [showOnlyUpdatedFields, setShowOnlyUpdatedFields] = useState(false);
  const [showOnlyFileFields, setShowOnlyFileFields] = useState(false);

  const toggleShowOnlyAISummaryFiles = useCallback(() => {
    setShowOnlyAISummaryFiles((prev) => !prev);
  }, []);

  const toggleShowOnlyUpdatedFields = useCallback(() => {
    setShowOnlyUpdatedFields((prev) => !prev);
  }, []);

  const toggleShowOnlyFileFields = useCallback(() => {
    setShowOnlyFileFields((prev) => !prev);
  }, []);

  return (
    <DueDiligenceFiltersContext.Provider
      value={{
        showOnlyAISummaryFiles,
        toggleShowOnlyAISummaryFiles,
        showOnlyUpdatedFields,
        toggleShowOnlyUpdatedFields,
        showOnlyFileFields,
        toggleShowOnlyFileFields,
      }}
    >
      {children}
    </DueDiligenceFiltersContext.Provider>
  );
};

export const useDueDiligenceFilters = () => {
  const {
    showOnlyAISummaryFiles,
    toggleShowOnlyAISummaryFiles,
    showOnlyUpdatedFields,
    toggleShowOnlyUpdatedFields,
    showOnlyFileFields,
    toggleShowOnlyFileFields,
  } = useContext(DueDiligenceFiltersContext);

  return {
    showOnlyAISummaryFiles,
    toggleShowOnlyAISummaryFiles,
    showOnlyUpdatedFields,
    toggleShowOnlyUpdatedFields,
    showOnlyFileFields,
    toggleShowOnlyFileFields,
  };
};
